// Primary Components
import WeeklySchedule from '../../components/Dashboard/WeeklySchedule/WeeklySchedule';
import DailyShiftSummaryPanel from '../../components/Dashboard/DailyShiftSummaryPanel/DailyShiftSummaryPanel';
import ShiftInformation from '../../components/ShiftInformation/ShiftInformation';
import AddShiftForm from '../../components/AddShiftForm/AddShiftForm';
import dayjs from 'dayjs';

/**
 * Drawer Types Enum
 * Hierarchy:
 * - Base Drawers (no parent)
 *   - Weekly Schedule
 *     - Day Drilldown
 *       - Shift Information
 *       - Add Shift Form
 */
export const DRAWER_TYPES = {
  // Base Drawer Types
  WEEKLY_SCHEDULE: 'weeklySchedule',

  // Weekly Schedule Children
  DAY_DRILLDOWN: 'dayDrilldown',

  // Shift Information
  SHIFT_INFORMATION: 'shiftInformation',

  // Add Shift Form
  ADD_SHIFT: 'addShift',
};

export const DRAWER_CONFIG = {
  // Base Drawer Types
  [DRAWER_TYPES.WEEKLY_SCHEDULE]: {
    component: WeeklySchedule,
    parent: null,
    props: ({ handleOpenDrawer }) => ({
      onDayClick: (data) => {
        const date = dayjs(data.selectedDay);
        handleOpenDrawer(
          DRAWER_TYPES.DAY_DRILLDOWN,
          {
            selectedDayShifts: data.shifts,
            selectedDay: data.selectedDay,
          },
          date.format('MMMM D, YYYY')
        );
      },
    }),
  },

  // Children of Weekly Schedule
  [DRAWER_TYPES.DAY_DRILLDOWN]: {
    component: DailyShiftSummaryPanel,
    parent: DRAWER_TYPES.WEEKLY_SCHEDULE,
    props: ({ drawerData, handleCloseDrawer, handleOpenDrawer }) => ({
      shifts: drawerData?.selectedDayShifts || [],
      selectedDay: drawerData?.selectedDay,
      onClose: handleCloseDrawer,
      handleOpenDrawer: (type, props, title) => {
        // Pass along the day context to child drawers
        handleOpenDrawer(
          type,
          {
            ...props,
            selectedDayShifts: drawerData?.selectedDayShifts,
            selectedDay: drawerData?.selectedDay,
          },
          title
        );
      },
    }),
  },

  // Children of DAY_DRILLDOWN/Daily Shift Summary Panel
  [DRAWER_TYPES.SHIFT_INFORMATION]: {
    component: ShiftInformation,
    parent: DRAWER_TYPES.DAY_DRILLDOWN,
    props: ({ drawerData, handleCloseDrawer, handleBackNavigation }) => ({
      shift: drawerData?.shift,
      selectedDay: drawerData?.selectedDay,
      selectedDayShifts: drawerData?.selectedDayShifts,
      handleCloseDrawer,
      handleBackNavigation,
      shouldNavigateBackOnDelete: true,
      isNewShift: false,
    }),
  },

  // Add Shift Form - can be opened from DAY_DRILLDOWN
  [DRAWER_TYPES.ADD_SHIFT]: {
    component: AddShiftForm,
    parent: DRAWER_TYPES.DAY_DRILLDOWN,
    props: ({ drawerData, handleCloseDrawer }) => ({
      onClose: handleCloseDrawer,
      selectedDate: drawerData?.selectedDate,
      dateFromShiftButton: drawerData?.dateFromShiftButton,
      preSelectedRole: drawerData?.preSelectedRole,
      handleSelectedDate: (date) => {
        // This can be used to update the parent component if needed
        console.log('Selected date:', date);
      },
    }),
  },
};
